import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Alert, Typography } from '@mui/material';

export default function InvalidFilesAlert({ invalidFiles, maxSize, setValid }) {
  const { t } = useTranslation();
  return (
    <Alert severity="error" sx={{ mb: 2 }} onClose={() => setValid(true)}>
      <Typography variant="body2" fontWeight="medium">
        {t('inputs.file.cannotRead')}
      </Typography>
      <Typography variant="body2">
        {invalidFiles.slice(0, 3).join(', ')}
        {invalidFiles.length > 3 && `... (+${invalidFiles.length - 3} more)`}
      </Typography>
      <Typography variant="body2">
        {t('inputs.file.verifyExtensionAndSize', { size: maxSize / 1024 / 1024 })}
      </Typography>
    </Alert>
  );
}

InvalidFilesAlert.propTypes = {
  invalidFiles: PropTypes.array,
  maxSize: PropTypes.number,
  setValid: PropTypes.func,
};
